export default {
    quantity_of_interest: 'Quantity of interest',
    is_reference_definition: 'Reference or Alternative',
    reference_id: 'Reference ID',
    case_definition: 'Case definition',
    parent_case_definition: 'Parent condition case definition',
    exclusion_criteria: 'Exclusion criteria',
    has_inpatient: 'Inpatient',
    has_outpatient: 'Outpatient',
    has_primary_care: 'Primary care',
    has_claims: 'Claims',
    has_survey: 'Survey',
    has_disease_registry: 'Disease registry',
    has_case_notification: 'Case notification',
    has_cohort_study: 'Cohort / longitudinal',
    has_intervention_study: 'Interventions / trials',
    has_case_control_study: 'Case control',
    has_case_series: 'Case series',
    has_self_report: 'Self-report',
    has_physical_biomarker: 'Physical measurement / biomarker (individual)',
    has_direct_observation: 'Direct observation',
    has_physician_diagnosis: 'Physician diagnosis',
    has_physical_monitoring: 'Physical measurement / monitoring (environment)',
    has_other_source_types: 'Other',
    other_source_type_notes: 'Other notes',
    non_fatal_icd9_codes: 'ICD9 codes (non-fatal, all)',
    non_fatal_icd10_codes: 'ICD10 codes (non-fatal, all)',
    fatal_icd9_codes: 'ICD9 codes (fatal)',
    fatal_icd10_codes: 'ICD10 codes (fatal)',
    non_fatal_female_age_group_restriction_ids: 'Non Fatal Female Ages Not Modeled',
    non_fatal_male_age_group_restriction_ids: 'Non Fatal Male Ages Not Modeled',
    fatal_female_age_group_restriction_ids: 'Fatal Female Ages Not Modeled',
    fatal_male_age_group_restriction_ids: 'Fatal Male Ages Not Modeled',
    non_fatal_location_restriction_ids: 'Non Fatal Locations Not Modeled',
    fatal_location_restriction_ids: 'Fatal Locations Not Modeled',
    fatal_data_source_link: 'Fatal Data Source Link',
    non_fatal_data_source_link: 'Non Fatal Data Source Link',
};
